import { BARCODE_BORDER_COLOR_HEX, TICKET_BG_COLOR_HEX } from '../../wallet/wallet.constants';
import { TicketModel } from '@/v2/models/ticketModel';
import { ProductModel } from '@/v2/models/productModel';
import { getVip } from '@/v2/helpers/additionalInfo/vipHelper';
import { getContrastingFontColor } from './contrastHelper';

export function getHeaderBackgroundColor(ticket: TicketModel): string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  return getVip(ticket).color ?? ticket.bgColorHex;
}

/**
 * A VIP colour brings its own foreground rather than borrowing the PBS one, which was picked to read
 * against `bgColorHex` and says nothing about the VIP background now underneath it.
 */
export function getTextFontColor(ticket: TicketModel): string | null {
  if (ticket.voidedAt != null) {
    return null;
  }
  const { color } = getVip(ticket);
  return color ? getContrastingFontColor(color) : ticket.fontColorHex;
}

export function getTicketBackgroundColor(model: TicketModel | ProductModel): string | null {
  if (model.voidedAt != null) {
    return null;
  }
  return TICKET_BG_COLOR_HEX;
}

export function getBarcodeBorderColor(model: TicketModel | ProductModel): string | null {
  if (model.voidedAt != null) {
    return null;
  }
  return BARCODE_BORDER_COLOR_HEX;
}
